import {
  GET_EMPLOYER_DOCUMENTS_BY_ID,
  GET_EMPLOYER_DOCUMENTS_BY_ID_SUCCESS,
  GET_EMPLOYER_DOCUMENTS_BY_QUERY,
  GET_EMPLOYER_DOCUMENTS_BY_QUERY_SUCCESS,
  EDIT_EMPLOYER_DOCUMENTS,
  UPLOAD_EMPLOYER_DOCUMENTS,
  DELETE_EMPLOYER_DOCUMENTS,
  EMPLOYER_DOCUMENT_ERROR,
} from './types';

const initState = {
  items: [],
  item: null,
  loading: false,
  itemCount: 0,
  pageCount: 0,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_EMPLOYER_DOCUMENTS_BY_QUERY:
    case EDIT_EMPLOYER_DOCUMENTS:
      return {
        ...state,
        loading: false,
      };

    case GET_EMPLOYER_DOCUMENTS_BY_ID:
      return {
        ...state,
        loading: false,
        editSuccess: false,
      };

    case UPLOAD_EMPLOYER_DOCUMENTS:
      return {
        ...state,
        loading: false,
        addSuccess: false,
      };

    case DELETE_EMPLOYER_DOCUMENTS:
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      };

    case GET_EMPLOYER_DOCUMENTS_BY_QUERY_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        loading: true,
        items: data,
        itemCount,
        pageCount,
        addSuccess: true,
        editSuccess: true,
        deleteSuccess: true,
      };

    case GET_EMPLOYER_DOCUMENTS_BY_ID_SUCCESS:
      return {
        ...state,
        loading: true,
        item: payload,
        error: null,
      };

    case EMPLOYER_DOCUMENT_ERROR:
      return { ...state, loading: true, error: payload };

    default:
      return { ...state };
  }
};
